// extracted by mini-css-extract-plugin
module.exports = {"totalCard":"TotalCard_totalCard__2B9fY","fadeIn":"TotalCard_fadeIn__1DL5V","fadeOut":"TotalCard_fadeOut__3N4Kh"};